import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { GridColDef } from '@mui/x-data-grid-pro';

export const useFixedColumns = () => {
  const { t } = useTranslation('common');
  return [
    {
      field: 'code',
      headerName: t('code'),
      hideable: false,
      flex: 1
    },
    {
      field: 'name',
      headerName: t('name'),
      flex: 1
    }
  ] as GridColDef[];
};

export const qualificationSchema = (t) =>
  yup.object({
    id: yup.string(),
    code: yup
      .string()
      .required(t('validationFieldRequired', { name: t('code') }))
      .default(''),
    name: yup
      .string()
      .required(
        t('validationFieldRequired', {
          name: t('name')
        })
      )
      .default('')
  });
